<template>
    <div>
        <kgr-member-honor-data-provider
            v-slot="honorsScope"
            :member-id="memberId"
            :callback="onHonorLoaded"
        >
            <kgr-form-scaffold
                :with-primary-buttons="false"
                @backBtnClicked="redirectToOverview"
            >
                <kgr-member-honors-data-form
                    :honors="honors"
                    :club-id="clubId"
                    :member-id="memberId"
                    class="animated fadeIn"
                    :is-deletable="isDeletable"
                    :is-creatable="isCreatable"
                    :is-editable="isEditable"
                    @updated="honorsScope.reload()"
                />
            </kgr-form-scaffold>
        </kgr-member-honor-data-provider>
    </div>
</template>

<script>
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberHonorDataForm from '../../components/members/honor/MemberHonorDataForm';
import MemberHonorDataProvider from '../../components/data-provider/MemberHonorDataProvider';

export default {
    components: {
        'kgr-member-honors-data-form':MemberHonorDataForm,
        'kgr-member-honor-data-provider': MemberHonorDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            honors: [],
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onHonorLoaded(honors) {
            this.honors = honors;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
